import React from "react"
import { shortDateLabel, stateLabel } from "./plannerLabels"
import { problemSubject } from "./publishingLabels"

// What a field the sending needs is called on screen (the calendar read's `missing.send`).
export const SEND_FIELD_LABELS = { organizer: "organizer", club: "club", playMode: "play mode" }
// What a draft lacks to be sent, or null when the read does not say (an API before sportya-api#605): then nothing is claimed.
export const missingToSend = item => (Array.isArray(item?.missing?.send) ? item.missing.send : null)

// The lines under a proposal's state: what it still needs to be sent, when it was sent or answered, and the marks of its sending
// (Phase C2a). A Confirmed proposal shows its answer and, once Ready to publish is read, what publishing still needs (Phase E2p).
export const stateLines = (item, timeZone) => {
  const line = (text, tone = "meta") => ({ text, tone })
  if (item.kind === "event") {
    return [item.cancelled && line("Cancelled"), item.status === "DISABLED" && line("Disabled"), item.needsFees && line("No fees", "error")].filter(Boolean)
  }
  const lines = []
  const missing = missingToSend(item)
  if (item.state === "draft" && missing) {
    lines.push(line(missing.length ? `To send: needs ${missing.map(field => SEND_FIELD_LABELS[field] || field).join(", ")}` : "Ready to send"))
  }
  if (item.state === "proposed") {
    if (item.marks?.notSentYet) lines.push(line("Not sent yet to its organizer"))
    else if (item.waitingSince) lines.push(line(`Sent ${shortDateLabel(item.waitingSince, timeZone)}`))
    if (item.marks?.changedAfterSent?.length) lines.push(line("Changed after it was sent"))
    if (item.marks?.needsNewConfirmation) lines.push(line("Needs a new confirmation"))
  }
  if (["confirmed", "refused"].includes(item.state) && item.answer?.at) {
    lines.push(line(`${item.state === "confirmed" ? "Confirmed" : "Declined"} ${shortDateLabel(item.answer.at, timeZone)}`))
  }
  if (item.state === "confirmed" && item.toPublish) {
    lines.push(line(item.toPublish.complete ? "Ready to publish"
      : `To publish: needs ${item.toPublish.problems.map(({ field }) => problemSubject(field, item.toPublish.competitions)).join(", ")}`))
  }
  return lines
}

export default function ItemState({ item, timeZone }) {
  return <span className="ep-stack">
    <span className={`ep-state ep-state-${item.state}`}>{stateLabel(item.state)}</span>
    {stateLines(item, timeZone).map(({ text, tone }) => <span key={text} className={tone === "error" ? "ep-mark ep-mark-error" : "ep-meta"}>{text}</span>)}
  </span>
}
